import { connect } from "react-redux";
import modeEnum from "../mode";
import actionCreators from "../redux/actionCreators";
import { getDocumentId, getDraft, getHasChanges, getMode } from "../redux/selectors";
import DocumentEditor from "./documentEditor";
const mapStateToProps = (state) => ({
    mode: getMode(state),
    draft: getDraft(state),
    documentId: getDocumentId(state),
    hasChanges: getHasChanges(state)
});
const mapDispatchToProps = (dispatch, ownProps) => ({
    onImportPreview: (file, completed) => dispatch(actionCreators.importPreview(file, completed)),
    onSaveDocument: (document, mode, fileAttach, importParams, completed) => {
        ownProps.onEditingInProgress && ownProps.onEditingInProgress(true, document.Id);
        Promise.resolve(dispatch(mode === modeEnum.DUPLICATE
            ? actionCreators.duplicateDocument(document)
            : actionCreators.saveDocument(document, Boolean(ownProps.activeNewDocumentAfterCreation), fileAttach, importParams))).then((promiseResult) => {
            var _a;
            ownProps.onEditingInProgress && ownProps.onEditingInProgress(false, document.Id);
            if (((_a = promiseResult === null || promiseResult === void 0 ? void 0 : promiseResult.response) === null || _a === void 0 ? void 0 : _a.Id) === undefined)
                return;
            ownProps.onClose && ownProps.onClose(document.Id);
            completed && completed();
        });
    },
    onSetDraft: (draft) => dispatch(actionCreators.setDraft(draft)),
    onGetProjects: (documentId, workspaceId, completed) => dispatch(actionCreators.getWorkSpaceProjects(documentId, workspaceId, completed))
});
export default connect(mapStateToProps, mapDispatchToProps)(DocumentEditor);
